import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      redirect: "Login",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        // Application
        {
          name: "Dashboard",
          path: "dashboard",
          component: () => import("@/pages/user/dashboard"),
        },
        {
          name: "Recyclebin",
          path: "recyclebin",
          component: () => import("@/pages/recyclebin"),
        },
        {
          name: "PO",
          path: "/PurchaseOrder",
          component: () => import("@/pages/po/poList"),
        },
        {
          name: "Lc_report",
          path: "/lcreport",
          component: () => import("@/pages/lc_report/lc_list"),
        },
        {
          name: "Lc_detail",
          path: "/createLc",
          component: () => import("@/pages/lc_details/lc_listing"),
        },
        {
          name: "Assemble_Request",
          path: "/assembly",
          component: () => import("@/pages/assemble/assemble_list"),
        },
        {
          name: "summary",
          path: "/assemblySummary",
          component: () => import("@/pages/assemble/assemble_summary"),
        },
        {
          name: "partsreports",
          path: "systemreports/partsreports",
          component: () => import("@/pages/reports/report_list"),
        },
        {
          name: "bincardreports",
          path: "systemreports/bincardreports",
          component: () => import("@/pages/reports/bincard"),
        },
        {
          name: "bincard",
          path: "/bincard",
          component: () => import("@/pages/bincard/cardlist"),
        },
        {
          name: "supplier",
          path: "settings/supplier",
          component: () => import("@/pages/supplier/supplier_list"),
        },
        {
          name: "parts",
          path: "settings/parts",
          component: () => import("@/pages/parts/parts"),
        },
        {
          name: "products",
          path: "settings/products",
          component: () => import("@/pages/products/product_list"),
        },
        {
          name: "employee",
          path: "settings/employee",
          component: () => import("@/pages/employee/employee_list"),
        },
        {
          name: "user",
          path: "settings/users",
          component: () => import("@/pages/user/user_list"),
        },
        {
          name: "Useraccess",
          path: "settings/useraccess",
          component: () => import("@/pages/useraccess"),
        }
      ],
    },

    {
      path: "/",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "Login",
          path: "Login",
          component: () => import("@/pages/authentication/login"),
        }
      ],
    },
    {
      path: "*",
      component: () => import("@/pages/authentication/Error"),
    },
  ],
});

import NProgress from "nprogress";

// router.beforeResolve((to, from, next) => {
//   // If this isn't an initial page load.
//   if (to.name) {
//     // Start the route progress bar.
//     NProgress.start(800);
//   }
//   next();
// });

router.beforeEach((to, from, next) => {

  const isLogin = localStorage.getItem('token') == null ? false : true
  NProgress.start(800);
  if (to.path != '/login') {
      if (isLogin == true) {
          next();
      } else {
          next('/login');   
      }
  } else {
      next();
  }
})


router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
